import { Row, Col, Container } from 'react-bootstrap';
import SectionTwoImg from '../../../Assets/Images/header_sectionTwo.svg';

import './style.scss';

const SectionTwo = () => {
  return (
    <section id="sectionTwo" className="py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="d-none d-md-block text-center mb-4 mb-md-0">
            <img 
              src={SectionTwoImg} 
              className="img-fluid" 
              alt="Diverse collection of restaurants, bars, nightclubs and dining venues available on the platform" 
              loading="lazy"
            />
          </Col>
          <Col xs={12} md={6} className="text-center text-md-start">
            <div className="sectionTwo-text">
              <h2 className="headerText display-5 fw-bold mb-4">
                Find Your Perfect Spot
              </h2>
              <p className="lead mb-4">
                Choose from thousands of verified restaurants, bars, lounges, and nightclubs. 
                Whether you're craving fine dining, casual eats, craft cocktails, or vibrant nightlife, 
                our platform connects you with the perfect venue for every mood and occasion.
              </p>
              {/* <div className="features-list">
                <div className="d-flex align-items-center mb-3">
                  <div className="feature-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '40px', height: '40px'}}>
                    <i className="fas fa-check"></i>
                  </div>
                  <div>
                    <h5 className="mb-1">Verified Restaurants</h5>
                    <small className="text-muted">Quality-checked dining establishments</small>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <div className="feature-icon bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '40px', height: '40px'}}>
                    <i className="fas fa-star"></i>
                  </div>
                  <div>
                    <h5 className="mb-1">Premium Venues</h5>
                    <small className="text-muted">Curated selection of top-rated spots</small>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <div className="feature-icon bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '40px', height: '40px'}}>
                    <i className="fas fa-clock"></i>
                  </div>
                  <div>
                    <h5 className="mb-1">Real-time Availability</h5>
                    <small className="text-muted">Live updates on table availability</small>
                  </div>
                </div>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SectionTwo;